import React from "react"
import { createRoot } from "react-dom/client"
import "./application.css"

import LoginPage from "../pages/LoginPage"
import ForgotPasswordPage from "../pages/ForgotPasswordPage"
import ResetPasswordPage from "../pages/ResetPasswordPage"
import SetupPasswordPage from "../pages/SetupPasswordPage"

const container = document.getElementById("root")
if (container) {
  const { page, alert, notice, token } = container.dataset

  let node: React.ReactNode

  if (page === "forgot-password") {
    node = <ForgotPasswordPage alert={alert || null} notice={notice || null} />
  } else if (page === "reset-password") {
    node = <ResetPasswordPage token={token ?? ""} alert={alert || null} notice={notice || null} />
  } else if (page === "setup-password") {
    node = <SetupPasswordPage token={token ?? ""} alert={alert || null} notice={notice || null} />
  } else {
    node = <LoginPage alert={alert || null} notice={notice || null} />
  }

  createRoot(container).render(<React.StrictMode>{node}</React.StrictMode>)
}
